import {
  OrganizationSummarySubscriptionDto,
  StripeSubscriptionSummaryDto,
} from "@intelligems/ig-types";
import {
  getActiveOrgSubscriptions,
  getRemainingTrialDays,
  isAnOrgSubscriptionActive,
} from "@intelligems/ig-utils";
import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";

export const useCheckSubscriptionStatus = (considerFreeTrial?: boolean) => {
  const orgSummary = useGetOrganizationSummary();

  const isSubscriptionActive = isAnOrgSubscriptionActive(orgSummary.data.org);

  return considerFreeTrial
    ? getRemainingTrialDays(orgSummary.data.org) > 0 || isSubscriptionActive
    : isSubscriptionActive;
};

export const useActiveSubscription = () => {
  const orgSummary = useGetOrganizationSummary();

  return getActiveOrgSubscriptions(orgSummary.data.org);
};

export const areOneOfTheseSubsActive = (
  activeSubs: (
    | StripeSubscriptionSummaryDto
    | OrganizationSummarySubscriptionDto
  )[],
  subNames: string[]
) => {
  return activeSubs.some((_sub) => {
    if ("stripeSubscriptionId" in _sub) {
      const sub = _sub;
      return subNames.some((subName) =>
        sub.stripeProductLinks.some(
          (pl) => pl.stripeProduct?.name?.toLowerCase() == subName.toLowerCase()
        )
      );
    } else {
      const sub = _sub as OrganizationSummarySubscriptionDto;
      return subNames.some((subName) => sub.name === subName);
    }
  });
};

export const useCheckFreeTrialStatus = () => {
  const adminOrg = useGetOrganizationSummary();

  if (!adminOrg.isSuccess) {
    return false;
  }

  const isSubscriptionActive = isAnOrgSubscriptionActive(adminOrg.data.org);

  return getRemainingTrialDays(adminOrg.data.org) && !isSubscriptionActive;
};
